<div class="container d-flex align-center justify-space-between column-gap-10">
  <ng-content select="[headerFlag]"></ng-content>
  <ng-container *ngFor="let item of headerItems">
    <div class="container-label align-center justify-{{
        item.justify || 'center'
      }} d-flex flex-{{ item.flexSize }}" [ngClass]="{ cursor: item.isOrder }"
      [attr.role]="item.isOrder ? 'button' : null"
      [attr.tabindex]="item.isOrder ? '0' : null"
      (click)="item.isOrder && changeOrderValue(item)"
      (keydown.enter)="item.isOrder && changeOrderValue(item)"
      (keydown.space)="item.isOrder && changeOrderValue(item)">
      <span class="pr-3">
        {{ item.label }}
      </span>
      <ng-container *ngIf="item.isOrder">
        <ng-container [ngSwitch]="item.orderValue">
          <div *ngSwitchCase="OrderEnum.NULL" class="fade-in">
            <app-svg-icon src="assets/icons/sort-null-icon.svg" width="17px" height="18px" color="white"></app-svg-icon>
          </div>
          <div *ngSwitchCase="OrderEnum.UP" class="fade-in">
            <app-svg-icon src="assets/icons/sort-up-icon.svg" width="17px" height="18px" color="white"></app-svg-icon>
          </div>
          <div *ngSwitchCase="OrderEnum.DOWN" class="fade-in">
            <app-svg-icon src="assets/icons/sort-down-icon.svg" width="17px" height="18px" color="white"></app-svg-icon>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-content select="[buttonSpace]"></ng-content>
</div>